import { Link } from 'react-router-dom';
import './CalanderLinks.scss';

const CalenderLinks = () => {
  return (
    <div className="calendar-links">
      <h2>Calendars</h2>
      <div className="card-grid">

        <Link to="/calender/hindu" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Hindu Calendar" />
          </div>
          <div className="text-part">
            <h3>Hindu</h3>
            <p>Traditional Hindu calendar with Tithi, festivals, and vrats.</p>
          </div>
        </Link>

        <Link to="/calender/indian" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Indian Calendar" />
          </div>
          <div className="text-part">
            <h3>Indian</h3>
            <p>National calendar with official Indian holidays and observances.</p>
          </div>
        </Link>

        <Link to="/calender/tamil" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Tamil Calendar" />
          </div>
          <div className="text-part">
            <h3>Tamil</h3>
            <p>Covers Tamil festivals, Muhurat, and auspicious dates.</p>
          </div>
        </Link>

        <Link to="/calender/malyalam" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Malayalam Calendar" />
          </div>
          <div className="text-part">
            <h3>Malayalam</h3>
            <p>Includes Onam and other regional Kerala events.</p>
          </div>
        </Link>

        <Link to="/calender/sankranti" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Sankranti" />
          </div>
          <div className="text-part">
            <h3>Sankranti</h3>
            <p>All Sankranti transitions throughout the year.</p>
          </div>
        </Link>

        <Link to="/calender/diwali" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Diwali Calendar" />
          </div>
          <div className="text-part">
            <h3>Diwali</h3>
            <p>Detailed Diwali calendar with Lakshmi Puja timings.</p>
          </div>
        </Link>

        <Link to="/calender/durgapuja" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Durga Puja Calendar" />
          </div>
          <div className="text-part">
            <h3>Durga Puja</h3>
            <p>Durga Puja festival calendar with daily rituals.</p>
          </div>
        </Link>

        <Link to="/calender/shardiya" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Shardiya Navratri" />
          </div>
          <div className="text-part">
            <h3>Shardiya Navratri</h3>
            <p>Festival details of Sharad Navratri with fasting rules.</p>
          </div>
        </Link>

        <Link to="/calender/chaitranavaratri" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Chaitra Navaratri" />
          </div>
          <div className="text-part">
            <h3>Chaitra Navaratri</h3>
            <p>Spring Navratri with Ghatasthapana and Kanya Pujan info.</p>
          </div>
        </Link>

        <Link to="/calender/odia" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Odia Calendar" />
          </div>
          <div className="text-part">
            <h3>Odia</h3>
            <p>Jagannath temple dates, Rath Yatra and regional events.</p>
          </div>
        </Link>

        <Link to="/calender/bengali" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Bengali Calendar" />
          </div>
          <div className="text-part">
            <h3>Bengali</h3>
            <p>Complete Bengali Panjika with yearly festivals.</p>
          </div>
        </Link>

        <Link to="/calender/gujrati" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Gujarati Calendar" />
          </div>
          <div className="text-part">
            <h3>Gujarati</h3>
            <p>Gujarati Vikram Samvat calendar with regional events.</p>
          </div>
        </Link>

        <Link to="/calender/marathi" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Marathi Calendar" />
          </div>
          <div className="text-part">
            <h3>Marathi</h3>
            <p>Marathi calendar with Gudi Padwa and other events.</p>
          </div>
        </Link>

        <Link to="/calender/telegu" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Telugu Calendar" />
          </div>
          <div className="text-part">
            <h3>Telugu</h3>
            <p>Andhra and Telangana regional Panchangam.</p>
          </div>
        </Link>

        <Link to="/calender/iskon" className="card">
          <div className="img-part">
            <img src="https://www.drupal.org/files/project-images/drupal-module-calendar.jpg" alt="Iskcon Calendar" />
          </div>
          <div className="text-part">
            <h3>ISKCON</h3>
            <p>Vaishnava calendar based on lunar tithis and events.</p>
          </div>
        </Link>

      </div>
    </div>
  );
};

export default CalenderLinks;
